<template>
<div>
  <div class="row">
    <AppliancesCurrentData></AppliancesCurrentData>
  </div>

  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-3">
      <Calendar numpickers=1></Calendar>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 order-xl-first">
      <AppliancesDecomposition></AppliancesDecomposition>
    </div> 
  </div>
</div>
</template>

<script>
import Calendar from './Calendar.vue'
import AppliancesDecomposition from './AppliancesDecomposition.vue'
import AppliancesCurrentData from './AppliancesCurrentData.vue'

export default {
  name: 'Appliances',
  components: {
    Calendar,
    AppliancesDecomposition,
    AppliancesCurrentData
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-inside-line {
  position:relative;
  margin-top: 20px;
  text-align: center;
}
.text-inside-line::before {
  content: "";
  display: block;
  border-top: solid 1px #8d8888;
  width: 100%;
  height: 1px;
  position: absolute;
  top: 50%;
  z-index: 1;
}
.text-inside-line > span {
  background: #f7f8fb;
  padding: 0 20px;
  position: relative;
  z-index: 5;
  text-align: center;
}
</style>
